// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3St1p","messages":"Chat_messages__QjzYi","dateDivider":"Chat_dateDivider__3hbDA"};